import DashboardSimplified from "./DashboardSimplified";
import DashboardDetailed from "./DashboardDetailed";
import { Container } from 'react-bootstrap';
import MainLayout from '../../../layouts/MainLayout';
import { T } from '../../../helpers/Language';
import { useState, useEffect } from "react";
import { getKpi, getFinancialSummary, getReportSummary } from "../../../api/actions/Reports";

const Dashboard = () => {
    const [kpiData, setKpiData] = useState({});
    const [financialSummaryData, setFinancialSummaryData] = useState({});
    const [reportSummaryData, setReportSummaryData] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const [initialized, setInitialized] = useState(false);
    const windowWidth = window.innerWidth;

    const getData = async () => {
        const [kpiResponse, FSResponse, RSResponse] = await Promise.allSettled([
            getKpi(),
            getFinancialSummary(),
            getReportSummary()
        ]);

        if (kpiResponse.status === 'fulfilled') setKpiData(kpiResponse.value);
        if (FSResponse.status === 'fulfilled') setFinancialSummaryData(FSResponse.value);
        if (RSResponse.status === 'fulfilled') setReportSummaryData(RSResponse.value);
        setIsLoading(false);
    }

    useEffect(() => {
        if (!initialized) {
            getData();
            setInitialized(true);
        }
    }, []);

    return (
        <MainLayout pageTitle={T('DASHBOARD_TITLE')}>
            <Container fluid className="reports-dashboard">
                <div className={`fiducialLoading ${isLoading ? 'active' : ''}`}>
                    <div className="progressbar"></div>
                </div>
                {windowWidth >= 1200 ?
                    (<DashboardDetailed
                        kpiData={kpiData}
                        financialSummaryData={financialSummaryData}
                        reportSummaryData={reportSummaryData}
                    />) : 
                    (<DashboardSimplified
                        kpiData={kpiData}
                        financialSummaryData={financialSummaryData}
                    />)
                }
            </Container>
        </MainLayout>
    );
}

export default Dashboard;
